import API from "@/api/";
import {
  SET_LIST,
  SET_CHNL,
  SET_TOTAL,
  SET_OFFSET,
  SET_MAX,
} from "./mutation-types";

export const list = ({ commit, state }, params = null) => {
  const newParams = params ?? {
    channel: state.chnl,
    max: state.max,
    offset: state.offset,
    sort: state.sort,
    order: state.order,
  };
  //console.log(`action.groupMember.list: newParams = ${JSON.stringify(newParams)}`);
  return new Promise((resolve) => {
    API.chnlOrgWhitelist.list(newParams).then((res) => {
      const { max, offset, channel } = newParams;
      //console.log(`max = ${max}, offset = ${offset}, newParams = ${JSON.stringify(newParams)};`);
      //console.log(`params = ${JSON.stringify(params)};`);
      if (res.status === 200) {
        commit(SET_LIST, res.data[0]);
        commit(SET_TOTAL, res.data[1]);
        if (channel !== undefined) {
          commit(SET_CHNL, channel);
        }
        if (offset !== undefined) {
          commit(SET_OFFSET, offset);
        }
        if (max !== undefined) {
          commit(SET_MAX, max);
        }
        resolve(res);
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    });
  });
};

export default {
  list,
};
